import { Injectable, OnDestroy } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Subject, Subscription } from 'rxjs';

import { ClubModel } from '@bayclubs/court-booking-employee-api';
import { utils } from '@bayclubs/ui-core';

import { SelectedClubChangedSuccess } from '../store/core.actions';
import { CoreFacade } from '../store/core.facade';
import { SignalRService } from './signal-r.service';

@Injectable({
    providedIn: 'root'
})
export class CourtBookingHubService implements OnDestroy {
    public courtEventChanged = new Subject<any>();

    private courtEventChangedMethodName = 'courtEventChanged';

    private joinClubMethodName = 'joinClub';
    private leaveClubChangedMethodName = 'leaveClub';

    private currentClubId: string;
    private subscription: Subscription = new Subscription();

    constructor(private signalR: SignalRService, private coreFacade: CoreFacade, private actions$: Actions) {
        this.subscription.add(this.signalR.connected$.subscribe(connected => {
            if (connected) {
                this.onClubChanged(this.coreFacade.selectedClub());
            } else {
                this.currentClubId = null;
            }
        }));

        this.subscription.add(
            this.actions$.pipe(ofActionSuccessful(SelectedClubChangedSuccess)).subscribe(action => {
                this.onClubChanged(action.club);
            })
        );

        this.registerListeners();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private registerListeners() {
        this.signalR.registerListener(this.courtEventChangedMethodName, message => this.courtEventChanged.next(message));
    }

    private onClubChanged(club: ClubModel) {
        if (this.currentClubId) {
            this.signalR.invokeMethod(this.leaveClubChangedMethodName, this.currentClubId);
        }
        if (club) {
            this.currentClubId = club.id;
            this.signalR.invokeMethod(this.joinClubMethodName, this.currentClubId);
        } else {
            this.currentClubId = null;
        }
    }
}

export interface CourtEventChangedSignalRMessage {
    courtEventId: string;
    clubId: string;
    date: utils.BcDate;
}